import { Component } from '@angular/core';

@Component({
  selector: 'nns-note-search',
  styles: [`
    :host {
      position: fixed;
      right: 15px;
      top: 70px;
      width: 325px;
      z-index: 1;
    }
  `],
  template: `
  `
})
export class NoteSearchComponent {
}
